gsap.registerPlugin(ScrollTrigger),
gsap.to(".big-text1 h2", {
    transform: "translateX(-100%)",
    scrollTrigger: {
        trigger: ".big-text1",
        scroller: "body",
        start: "top 70%",
        end: "top 10%",
        toggleActions: "restart none none reverse",
        scrub: 3
    }
});

const lenis = new Lenis({
    smoothWheel: !0,
    smoothTouch: !1,
    normalizeWheel: !0,
    ignore: el => el.classList.contains("scroll-section")
});
lenis.on("scroll", ScrollTrigger.update),
gsap.ticker.add(time => {
    lenis.raf(time * 700)
}
),
gsap.ticker.lagSmoothing(0),
document.addEventListener("DOMContentLoaded", function() {
    const logo = document.querySelector(".logo");
    window.addEventListener("scroll", function() {
        window.scrollY > 50 ? (logo.classList.remove("not-scrolled"),
        logo.classList.add("scrolled")) : (logo.classList.remove("scrolled"),
        logo.classList.add("not-scrolled"))
    })
}),


document.addEventListener("DOMContentLoaded", function() {
    const navbar = document.querySelector(".navbar");
    function handleScroll() {
        if (window.innerWidth <= 950) {
            if (navbar.getAttribute("data-page") != "home")
                return;
            window.scrollY > 50 ? (navbar.style.transition = "background-color 0.4s ease-in-out",
            navbar.classList.add("nav-bg_white"),
            navbar.style.backgroundColor = "transparent") : (navbar.style.backgroundColor = "transparent",
            navbar.classList.remove("nav-bg_white"))
        } else
            navbar.style.backgroundColor = ""
    }
    window.addEventListener("scroll", handleScroll),
    window.addEventListener("resize", handleScroll)
}),
document.addEventListener("DOMContentLoaded", function() {
    const navbar = document.querySelector(".navbar");
    let lastScrollY = window.scrollY;
    function handleScroll() {
        if (window.innerWidth > 950) {
            navbar.style.backgroundColor = "",
            navbar.classList.remove("nav-bg_white");
            return
        }
        if (navbar.getAttribute("data-page") !== "home")
            return;
        const currentScrollY = window.scrollY;
        navbar.style.transition = "background-color 0.1s ease-in-out",
        currentScrollY < 50 ? (navbar.style.backgroundColor = "transparent",
        navbar.classList.remove("bg_change"),
        navbar.classList.remove("nav-bg_white")) : currentScrollY < lastScrollY ? (navbar.style.backgroundColor = "#fff",
        navbar.classList.add("bg_change")) : (navbar.classList.remove("bg_change"),
        navbar.classList.add("nav-bg_white"),
        navbar.style.backgroundColor = "transparent"),
        lastScrollY = currentScrollY
    }
    window.addEventListener("scroll", handleScroll),
    window.addEventListener("resize", handleScroll)
});


document.addEventListener("scroll", function() {
    const triggerSections = document.querySelectorAll(".custom-featured-collection")
      , navbar = document.querySelector(".navbar");
    if (!triggerSections.length || !navbar)
        return;
    const scrollPosition = window.scrollY
      , navbarHeight = navbar.offsetHeight
      , navbarBottom = scrollPosition + navbarHeight;
    let isInsideAnySection = !1;
    triggerSections.forEach(section => {
        const sectionTop = section.offsetTop
          , sectionBottom = sectionTop + section.offsetHeight;
        navbarBottom >= sectionTop && scrollPosition <= sectionBottom && (isInsideAnySection = !0)
    }
    ),
    isInsideAnySection ? navbar.classList.add("svg_change") : navbar.classList.remove("svg_change")
}),
document.addEventListener("DOMContentLoaded", function() {
    const navbar = document.querySelector(".navbar");
    if (!navbar)
        return;
    const page = navbar.getAttribute("data-page");
    function checkMobile() {
        window.innerWidth <= 950 && page !== "home" ? navbar.classList.add("bg_change") : navbar.classList.remove("bg_change")
    }
    checkMobile(),
    window.addEventListener("resize", checkMobile)
});


